var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useLanguage } from '../../base/LanguageProvider';
import FSButton from '../../components/FSButton';
import { createEntryLinkPath, EXPIRATION_OPTIONS } from '../../data/entryLink/entryLink';
import { useCreateEntryLink, useDeleteEntryLink, useDeleteEntryLinks, useEntryLink, useEntryLinksByIds, useUpdateBatchEntryLinks, useUpdateEntryLink, } from '../../data/entryLink/entryLinkActions';
import { useActiveVersions } from '../../data/hooks/versions';
import { useTagContext } from '../../data/tag/tagContext';
import { useAuth } from '../../providers/AuthProvider';
import FormInput from '../../shared/forms/FormInput';
import { Copy } from '../../shared/icons/icons';
import { CheckBox } from '../../shared/input/CheckBox';
import CheckboxMenu from '../../shared/input/CheckboxMenu';
import IntervalSelect from '../../shared/input/IntervalSelect';
import SelectInput from '../../shared/input/SelectInput';
import Manager from '../../shared/modal/Manager';
import Modal from '../../shared/modal/Modal';
import ModalHeader from '../../shared/modal/ModalHeader';
import { FormField, FormFieldErrorHelp, FormFieldLabel } from '../../styled/Form';
import { ModalBody } from '../../styled/Modal';
function CopyLinkModal(props) {
    var L = useLanguage().L;
    var entryLinkKey = props.entryLinkKey;
    var entryLinkPath = createEntryLinkPath(entryLinkKey);
    return (React.createElement(Modal, { width: 500 },
        React.createElement(ModalHeader, { title: L('Entry Link') }),
        React.createElement(ModalBody, null,
            React.createElement("div", { style: { display: 'grid', gridTemplateColumns: 'auto 50px', gap: 10, alignItems: 'center' } },
                React.createElement(FormInput, { label: L('Entry Link'), value: entryLinkPath, disabled: true, type: "text", name: "entryLink" }),
                React.createElement(FSButton, { icon: Copy, "$type": "tertiary", "$color": "neutral", onClick: function () {
                        window.navigator.clipboard.writeText(entryLinkPath);
                        toast.success(L('Entry link copied to clipboard'));
                    } }))),
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'end', padding: 15, paddingTop: 0 } },
            React.createElement(FSButton, { title: "OK", onClick: Manager.closeModal }))));
}
export function RegenerateLinksConfirmationModal(props) {
    var _this = this;
    var L = useLanguage().L;
    return (React.createElement(Modal, { width: 500 },
        React.createElement(ModalHeader, { title: L('Regenerate selected links?') }),
        React.createElement(ModalBody, null,
            React.createElement("div", { style: { lineHeight: 1.5 } }, L('Are you sure you want to regenerate the selected links? The selected entry links will be regenerated and the old links will be invalid. This action cannot be undone.'))),
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'end', padding: 15, paddingTop: 0 } },
            React.createElement(FSButton, { title: "Cancel", "$color": "neutral", "$type": "tertiary", style: { marginRight: 16 }, onClick: Manager.closeModal }),
            React.createElement(FSButton, { title: "Regenerate", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, props.onConfirm()];
                            case 1:
                                _a.sent();
                                Manager.closeModal();
                                return [2 /*return*/];
                        }
                    });
                }); } }))));
}
function aggregateDate(aggDate, date) {
    if (aggDate === undefined) {
        return date;
    }
    if (!!aggDate && aggDate.getFullYear() !== date.getFullYear()) {
        return null;
    }
    return aggDate;
}
function aggregateIds(aggIds, ids) {
    if (aggIds === undefined) {
        return ids;
    }
    if (!!aggIds && !(aggIds.every(function (id) { return ids.includes(id); }) && ids.every(function (id) { return aggIds.includes(id); }))) {
        return null;
    }
    return aggIds;
}
function aggregateDuration(aggDuration, duration) {
    if (aggDuration === undefined) {
        return duration;
    }
    if (!!aggDuration && aggDuration !== duration) {
        return null;
    }
    return aggDuration;
}
export function EntryLinkModal(props) {
    var e_1, _a;
    var _b, _c, _d, _e, _f, _g;
    var entryLinkId = props.entryLinkId, entryLinkIds = props.entryLinkIds, path = props.path, tableTagId = props.tableTagId, filterTagIds = props.filterTagIds, filteredDimensionTagIds = props.filteredDimensionTagIds;
    var _h = __read(useState({}), 2), errors = _h[0], setErrors = _h[1];
    var L = useLanguage().L;
    var settings = useAuth().settings;
    var activeVersions = useActiveVersions();
    var entryLink = useEntryLink(entryLinkId);
    var updateEntryLink = useUpdateEntryLink();
    var updateBatchEntryLink = useUpdateBatchEntryLinks();
    var createEntryLink = useCreateEntryLink();
    var tagData = useTagContext().tagData;
    var aggregatedEntryLinks = useEntryLinksByIds(entryLinkIds, {
        select: function (links) {
            var aggLinks = links.reduce(function (agg, l) {
                agg.intervalEnd = aggregateDate(agg.intervalEnd, l.intervalEnd);
                agg.intervalStart = aggregateDate(agg.intervalStart, l.intervalStart);
                agg.duration = aggregateDuration(agg.duration, l.duration);
                agg.versionIds = aggregateIds(agg.versionIds, l.versionIds);
                agg.maxIntervalStart =
                    agg.maxIntervalStart === undefined ||
                        agg.maxIntervalStart.getFullYear() < l.intervalStart.getFullYear()
                        ? l.intervalStart
                        : agg.maxIntervalStart;
                agg.minIntervalEnd =
                    agg.minIntervalEnd === undefined ||
                        agg.minIntervalEnd.getFullYear() < l.intervalStart.getFullYear()
                        ? l.intervalEnd
                        : agg.minIntervalEnd;
                return agg;
            }, {
                sheetRowId: null,
            });
            return aggLinks;
        },
    });
    var start = new Date().getFullYear();
    var end = new Date().getFullYear();
    try {
        for (var _j = __values(settings.model_table_filtered_years), _k = _j.next(); !_k.done; _k = _j.next()) {
            var y = _k.value;
            if (!start || start > y) {
                start = y;
            }
            if (!end || end > y) {
                end = y;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_k && !_k.done && (_a = _j.return)) _a.call(_j);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var _l = __read(useState(false), 2), generate = _l[0], setGenerate = _l[1];
    var _m = __read(useState((_b = entryLink.data) !== null && _b !== void 0 ? _b : {
        path: path !== null && path !== void 0 ? path : '0',
        duration: 28,
        intervalEnd: new Date(end, 11, 1, 1, 12),
        intervalStart: new Date(start, 0, 1, 1, 12),
        versionIds: [],
    }), 2), newEntryLink = _m[0], setNewEntryLink = _m[1];
    var _o = __read(useState((_c = aggregatedEntryLinks.data) !== null && _c !== void 0 ? _c : {
        sheetRowId: null,
        duration: null,
        intervalEnd: null,
        intervalStart: null,
        versionIds: null,
        maxIntervalStart: new Date(end, 11, 1, 1, 12),
        minIntervalEnd: new Date(start, 0, 1, 1, 12),
    }), 2), newAggEntryLink = _o[0], setNewAggEntryLink = _o[1];
    var tableTag = tagData.tagById[tableTagId !== null && tableTagId !== void 0 ? tableTagId : 0];
    var areVersionsMixed = ((_d = aggregatedEntryLinks.data) === null || _d === void 0 ? void 0 : _d.versionIds) === null && entryLinkIds;
    var areDurationsMixed = ((_e = aggregatedEntryLinks.data) === null || _e === void 0 ? void 0 : _e.duration) === null && entryLinkIds;
    var areStartIntervalsMixed = ((_f = aggregatedEntryLinks.data) === null || _f === void 0 ? void 0 : _f.intervalStart) === null && entryLinkIds;
    var areEndIntervalsMixed = ((_g = aggregatedEntryLinks.data) === null || _g === void 0 ? void 0 : _g.intervalEnd) === null && entryLinkIds;
    var isLoading = updateBatchEntryLink.isLoading ||
        updateEntryLink.isLoading ||
        createEntryLink.isLoading ||
        entryLink.isFetching;
    var versionItems = activeVersions.map(function (v) {
        var _a;
        return ({
            checked: entryLinkIds ? !!((_a = newAggEntryLink.versionIds) === null || _a === void 0 ? void 0 : _a.includes(v.id)) : newEntryLink.versionIds.includes(v.id),
            label: v.name,
            onToggle: function (newChecked) {
                if (entryLinkIds) {
                    setNewAggEntryLink(function (current) {
                        var _a, _b, _c;
                        var filtered = (_b = (_a = current.versionIds) === null || _a === void 0 ? void 0 : _a.filter(function (id) { return id !== v.id; })) !== null && _b !== void 0 ? _b : null;
                        return __assign(__assign({}, current), { versionIds: newChecked
                                ? __spreadArray(__spreadArray([], __read(((_c = current.versionIds) !== null && _c !== void 0 ? _c : [])), false), [v.id], false) : (filtered === null || filtered === void 0 ? void 0 : filtered.length) === 0
                                ? null
                                : filtered });
                    });
                    return;
                }
                setNewEntryLink(function (current) {
                    return __assign(__assign({}, current), { versionIds: newChecked
                            ? __spreadArray(__spreadArray([], __read(current.versionIds), false), [v.id], false) : current.versionIds.filter(function (id) { return id !== v.id; }) });
                });
            },
        });
    });
    function validate(el) {
        var errs = {};
        if (!el.path) {
            errs.sheetRowId = L('No row selected');
        }
        if (!el.duration) {
            errs.duration = L('No duration specified');
        }
        if (!el.intervalEnd) {
            errs.intervalEnd = L('Please set end of interval');
        }
        if (!el.intervalStart) {
            errs.intervalStart = L('Please set start of interval');
        }
        if (el.intervalStart && el.intervalEnd && el.intervalStart.getFullYear() > el.intervalEnd.getFullYear()) {
            errs.intervalStart = L('Start of interval is greater than the end');
        }
        if (el.versionIds.length === 0) {
            errs.versionIds = L('No version selected');
        }
        setErrors(errs);
        return Object.keys(errs).length === 0;
    }
    function validateAggregated(agg) {
        var errs = {};
        if (agg.versionIds !== null && agg.versionIds.length === 0) {
            errs.versionIds = L('No version selected');
        }
        if (agg.intervalStart &&
            !agg.intervalEnd &&
            agg.intervalStart.getFullYear() > agg.minIntervalEnd.getFullYear()) {
            errs.intervalStart = L('Start of interval greater than some of the interval ends');
        }
        if (agg.intervalEnd &&
            !agg.intervalStart &&
            agg.maxIntervalStart.getFullYear() > agg.intervalEnd.getFullYear()) {
            errs.intervalStart = L('End of interval lesser than some of the interval starts');
        }
        if (agg.intervalStart && agg.intervalEnd && agg.intervalStart.getFullYear() > agg.intervalEnd.getFullYear()) {
            errs.intervalStart = L('Start of interval greater than the end');
        }
        setErrors(errs);
        return Object.keys(errs).length === 0;
    }
    function update(updatedEntryLink) {
        var loadingId = toast.loading('Updating data entry link...');
        updateEntryLink.mutate(updatedEntryLink, {
            onSuccess: function () {
                toast.dismiss(loadingId);
                toast.success('Data entry link updated!');
            },
            onError: function (error) {
                toast.dismiss(loadingId);
                toast.error('Failed to update entry link.');
            },
        });
    }
    function updateBatch(batch) {
        var loadingId = toast.loading('Updating data entry links...');
        updateBatchEntryLink.mutate(batch, {
            onSuccess: function () {
                toast.dismiss(loadingId);
                toast.success('Data entry links updated!');
            },
            onError: function (error) {
                toast.dismiss(loadingId);
                toast.error('Failed to update entry links.');
            },
        });
    }
    function create(el, mutateType) {
        if (mutateType === void 0) { mutateType = 'mutate'; }
        var loadingId = toast.loading(L('Creating new data entry link...'));
        return createEntryLink[mutateType](el, {
            onSuccess: function (data) {
                toast.dismiss(loadingId);
                toast.success(L('New data entry link created!'));
                if (mutateType === 'mutateAsync') {
                    return;
                }
                Manager.closeModal();
                Manager.renderModal(React.createElement(CopyLinkModal, { entryLinkKey: data.key }));
            },
            onError: function (error) {
                toast.dismiss(loadingId);
                toast.error(L('Failed to create new entry link'));
            },
        });
    }
    function submitHandler(e) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function () {
            var filterCopy, filteredDimensionTagIds_1, filteredDimensionTagIds_1_1, tagId, filterCopy, e_2_1;
            var e_2, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        e.preventDefault();
                        if (!entryLinkIds && !validate(newEntryLink)) {
                            return [2 /*return*/];
                        }
                        if (entryLinkId && entryLink.data && newEntryLink.intervalStart && newEntryLink.intervalEnd) {
                            newEntryLink.intervalEnd.setHours(12);
                            newEntryLink.intervalStart.setHours(12);
                            update(__assign(__assign(__assign({}, entryLink.data), newEntryLink), { intervalEnd: newEntryLink.intervalEnd, intervalStart: newEntryLink.intervalStart, id: entryLinkId }));
                            return [2 /*return*/];
                        }
                        if (entryLinkIds) {
                            if (newAggEntryLink.duration === null &&
                                newAggEntryLink.versionIds === null &&
                                newAggEntryLink.intervalEnd === null &&
                                newAggEntryLink.intervalStart === null) {
                                setErrors({ global: 'No changes' });
                                return [2 /*return*/];
                            }
                            if (!validateAggregated(newAggEntryLink)) {
                                return [2 /*return*/];
                            }
                            (_a = newAggEntryLink.intervalEnd) === null || _a === void 0 ? void 0 : _a.setHours(12);
                            (_b = newAggEntryLink.intervalStart) === null || _b === void 0 ? void 0 : _b.setHours(12);
                            updateBatch({
                                ids: entryLinkIds,
                                updates: {
                                    duration: (_c = newAggEntryLink.duration) !== null && _c !== void 0 ? _c : undefined,
                                    versionIds: (_d = newAggEntryLink.versionIds) !== null && _d !== void 0 ? _d : undefined,
                                    intervalStart: (_e = newAggEntryLink.intervalStart) !== null && _e !== void 0 ? _e : undefined,
                                    intervalEnd: (_f = newAggEntryLink.intervalEnd) !== null && _f !== void 0 ? _f : undefined,
                                },
                            });
                            return [2 /*return*/];
                        }
                        if (!(tableTag && filterTagIds && filteredDimensionTagIds)) {
                            create(__assign(__assign({}, newEntryLink), { filterTagIds: [] }));
                            return [2 /*return*/];
                        }
                        if (!generate) return [3 /*break*/, 9];
                        if (filteredDimensionTagIds.length === 1) {
                            filterCopy = __spreadArray([], __read(filterTagIds), false);
                            filterCopy[filterCopy.length - 1] = filteredDimensionTagIds[0];
                            create(__assign(__assign({}, newEntryLink), { filterTagIds: filterCopy }));
                            return [2 /*return*/];
                        }
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 6, 7, 8]);
                        filteredDimensionTagIds_1 = __values(filteredDimensionTagIds), filteredDimensionTagIds_1_1 = filteredDimensionTagIds_1.next();
                        _h.label = 2;
                    case 2:
                        if (!!filteredDimensionTagIds_1_1.done) return [3 /*break*/, 5];
                        tagId = filteredDimensionTagIds_1_1.value;
                        filterCopy = __spreadArray([], __read(filterTagIds), false);
                        filterCopy[filterCopy.length - 1] = tagId;
                        return [4 /*yield*/, create(__assign(__assign({}, newEntryLink), { filterTagIds: filterCopy }), 'mutateAsync')];
                    case 3:
                        _h.sent();
                        _h.label = 4;
                    case 4:
                        filteredDimensionTagIds_1_1 = filteredDimensionTagIds_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_2_1 = _h.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (filteredDimensionTagIds_1_1 && !filteredDimensionTagIds_1_1.done && (_g = filteredDimensionTagIds_1.return)) _g.call(filteredDimensionTagIds_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                    case 9:
                        create(__assign(__assign({}, newEntryLink), { filterTagIds: filterTagIds }));
                        return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement(Modal, { width: 500 },
        React.createElement(ModalHeader, { title: L(entryLinkId ? 'Edit Entry Link' : entryLinkIds ? 'Edit Entry Links' : 'New Entry Link') }),
        React.createElement(ModalBody, null,
            React.createElement("form", { onSubmit: submitHandler },
                React.createElement(FormField, { "$bottomSpace": true, style: { flexGrow: 0 } },
                    React.createElement(FormFieldLabel, null, L('Version')),
                    React.createElement(CheckboxMenu, { showSelected: true, items: versionItems, title: L(areVersionsMixed ? 'Mixed Versions' : 'Select a Version'), size: "large" }),
                    React.createElement(FormFieldErrorHelp, null, errors.versionIds)),
                React.createElement("div", { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 } },
                    React.createElement(IntervalSelect, { none: {
                            from: areStartIntervalsMixed ? 'Mixed' : undefined,
                            to: areEndIntervalsMixed ? 'Mixed' : undefined,
                        }, type: "years", size: "large", end: entryLinkIds ? newAggEntryLink.intervalEnd : newEntryLink.intervalEnd, start: entryLinkIds ? newAggEntryLink.intervalStart : newEntryLink.intervalStart, onChange: function (e) {
                            if (entryLinkIds) {
                                var copy_1 = e.name === 'end'
                                    ? __assign(__assign({}, newAggEntryLink), { intervalEnd: e.value }) : __assign(__assign({}, newAggEntryLink), { intervalStart: e.value });
                                setNewAggEntryLink(copy_1);
                                return;
                            }
                            var copy = e.name === 'end'
                                ? __assign(__assign({}, newEntryLink), { intervalEnd: e.value }) : __assign(__assign({}, newEntryLink), { intervalStart: e.value });
                            setNewEntryLink(copy);
                        } })),
                React.createElement(FormFieldErrorHelp, null, errors.intervalStart),
                React.createElement(FormFieldErrorHelp, null, errors.intervalEnd),
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Expires After')),
                    React.createElement(SelectInput, { value: entryLinkIds ? newAggEntryLink.duration : newEntryLink.duration, options: areDurationsMixed
                            ? __spreadArray([{ value: null, label: 'Mixed' }], __read(EXPIRATION_OPTIONS), false) : EXPIRATION_OPTIONS, onChange: function (e) {
                            if (entryLinkIds) {
                                setNewAggEntryLink(__assign(__assign({}, newAggEntryLink), { duration: e.target.value }));
                                return;
                            }
                            setNewEntryLink(__assign(__assign({}, newEntryLink), { duration: e.target.value }));
                        } }),
                    React.createElement(FormFieldErrorHelp, null, errors.duration)),
                tableTag ? (React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(CheckBox, { label: L('Create an Entry Link for Each Dimension of Table ') + '"' + tableTag.name + '"', checked: generate, action: function () {
                            setGenerate(!generate);
                        } }))) : null,
                React.createElement(FormFieldErrorHelp, null, errors.global),
                React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'end' } },
                    React.createElement(FSButton, { "$type": "tertiary", type: "button", disabled: isLoading, title: L('Close'), onClick: Manager.closeModal, style: { marginRight: 15 } }),
                    React.createElement(FSButton, { title: L(entryLinkId || entryLinkIds ? 'Save' : 'Create'), type: "submit", loading: isLoading, disabled: entryLink.isFetching }))))));
}
export function DeleteEntryLinkModal(props) {
    var entryLinkId = props.entryLinkId, entryLinkIds = props.entryLinkIds;
    var L = useLanguage().L;
    var deleteEntryLink = useDeleteEntryLink();
    var deleteEntryLinks = useDeleteEntryLinks();
    function remove(command) {
        var isBatch = Array.isArray(command);
        var loadingId = toast.loading(isBatch ? 'Deleting data entry links...' : 'Deleting data entry link...');
        var mutationOptions = {
            onSuccess: function () {
                var _a;
                toast.dismiss(loadingId);
                toast.success(isBatch ? 'Data entry links deleted!' : 'Data entry link deleted!');
                (_a = props.onSuccess) === null || _a === void 0 ? void 0 : _a.call(props);
                Manager.closeModal();
            },
            onError: function () {
                toast.dismiss(loadingId);
                toast.error(isBatch ? 'Failed to delete entry links' : 'Failed to delete target entry link');
            },
        };
        if (isBatch) {
            deleteEntryLinks.mutate(command, mutationOptions);
            return;
        }
        deleteEntryLink.mutate(command, mutationOptions);
    }
    function submitHandler(e) {
        e.preventDefault();
        var command = entryLinkId !== null && entryLinkId !== void 0 ? entryLinkId : entryLinkIds;
        if (command !== undefined) {
            remove(command);
        }
    }
    return (React.createElement(Modal, { width: 500 },
        React.createElement(ModalHeader, { title: L(entryLinkId ? 'Delete Entry Link' : 'Delete Entry Links') }),
        React.createElement(ModalBody, null,
            React.createElement("form", { onSubmit: submitHandler },
                React.createElement("div", null, L(entryLinkId
                    ? 'Do you want to delete entry link'
                    : 'Do you want to delete selected entry links') + '?'),
                React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'end' } },
                    React.createElement(FSButton, { "$type": "tertiary", type: "button", disabled: deleteEntryLink.isLoading || deleteEntryLinks.isLoading, title: L('Close'), onClick: Manager.closeModal, style: { marginRight: 15 } }),
                    React.createElement(FSButton, { title: L('Delete'), type: "submit", "$color": "error", loading: deleteEntryLink.isLoading || deleteEntryLinks.isLoading }))))));
}
